export default "__VITE_PUBLIC_ASSET__3ded16d8__"